'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PaymentLogo = undefined;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _CloudinaryImage = require('web-makeup/dist/CloudinaryImage');

var _CloudinaryImage2 = _interopRequireDefault(_CloudinaryImage);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _InvoicePayment = require('../InvoicePayment/InvoicePayment.style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var __makeTemplateObject = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    } else {
        cooked.raw = raw;
    }
    return cooked;
};

var StripeImage = (0, _styledComponents2.default)(_CloudinaryImage2.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  img {\n    width: 115px;\n  }\n"], ["\n  img {\n    width: 115px;\n  }\n"])));
var PaymentLogo = exports.PaymentLogo = function PaymentLogo() {
    return React.createElement(_InvoicePayment.AlignedContainer, null, React.createElement(_CloudinaryImage2.default, { useSourceFormat: true, source: {
            id: '-icons-browse-order-deliver/-deliver/shopify-ssl-secured',
            type: 'upload'
        } }), React.createElement(StripeImage, { useSourceFormat: true, source: {
            id: 'v1/-icons-browse-order-deliver/-order/-configure/badge-stripe',
            type: 'upload'
        } }));
};
var templateObject_1;
//# sourceMappingURL=PaymentLogo.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/order/views/pay-page/PaymentLogo/PaymentLogo.js
// module id = 991
// module chunks = 0